import React, { useState } from "react";
import { makeStyles } from "tss-react/mui";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import MenuDropdown from "./MenuDropdown";
import ColourConstants from "helpers/colourConstants";
import PropTypes from "prop-types";

const media = "@media(max-width: 768px)";

const useStyles = makeStyles()((theme) => ({
	desktopNav: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		"& > *": {
			margin: theme.spacing(1),
		},
		[media]: {
			display: "none",
		},
	},

	mobileNav: {
		display: "none",
		[media]: {
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			"& > *": {
				margin: theme.spacing(1),
			},
		},
	},
	background: {
		[media]: {
			position: " absolute",
			top: 0,
			left: 0,
			height: "100vh",
			width: "100vw",
		},
	},
	buttonGroup: {
		width: "99.5%",
	},
	curveButton: {
		borderRadius: 50,
		borderWidth: 1,
		borderColor: ColourConstants.navButtonOnHover,
		fontWeight: "bold",
		fontSize: "14.5px",
		fontFamily: "Roboto Condensed",
		letterSpacing: 0,
		color: ColourConstants.navButtonTextColor,
		"&:hover": {
			backgroundColor: ColourConstants.navButtonOnHover,
			color: "#FFFFFF",
			borderColor: ColourConstants.navButtonOnHover,
		},
	},
	curveButtonCurrent: {
		backgroundColor: ColourConstants.navButtonOnHover,
		color: "#FFFFFF",
	},
}));

const NavButtons = ({
	navigation,
	applicationName,
	current,
	onClick,
	hideMobileViewBackground,
	role,
	testIdPrefix,
}) => {
	// Init hooks
	const { classes, cx } = useStyles();

	// Init State
	const [selectedButton, setSelectedButton] = useState(null);
	const [anchorEl, setAnchorEl] = useState(null);

	const [selectedButtonMobile, setSelectedButtonMobile] = useState(null);
	const [anchorElMobile, setAnchorElMobile] = useState(null);

	return (
		<>
			<div
				className={hideMobileViewBackground ? "" : classes.background}
				onClick={() => {
					setAnchorElMobile(null);
					setSelectedButtonMobile(null);
				}}
			></div>
			<div className={` buttonGroup ${classes.desktopNav}`}>
				<ButtonGroup
					fullWidth={true}
					className={`${classes.buttonGroup} `}
					aria-label="outlined primary button group"
					size="small"
				>
					{navigation.map((navItem, index) => {
						// TODO: below is updated zeroth button to be current. This needs to come
						// from state in prod

						return (
							<Button
								data-testid={
									testIdPrefix
										? `${testIdPrefix}-${navItem.name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`
										: undefined
								}
								className={`${
									navItem.name === current
										? cx(classes.curveButton, classes.curveButtonCurrent)
										: classes.curveButton
								} largeBtn`}
								onMouseEnter={(e) => {
									setAnchorEl(e.currentTarget);
									setSelectedButton(index);
								}}
								onMouseLeave={() => {
									setAnchorEl(null);
									setSelectedButton(null);
								}}
								onClick={() => {
									onClick(navItem.url);
								}}
								key={index}
								disabled={navItem?.disableTo?.includes(role)}
							>
								{navItem.name}
								{navItem?.dropdown?.length > 0 && (
									<MenuDropdown
										index={index}
										selectedButton={selectedButton}
										anchorEl={anchorEl}
										content={navItem.dropdown}
										applicationName={applicationName}
									/>
								)}
							</Button>
						);
					})}
				</ButtonGroup>
			</div>
			<div className={`buttonGroup ${classes.mobileNav}`}>
				<ButtonGroup
					fullWidth={true}
					className={`${classes.buttonGroup} `}
					aria-label="outlined primary button group"
					size="small"
				>
					{navigation.map((navItem, index) => {
						// TODO: below is updated zeroth button to be current. This needs to come
						// from state in prod

						return (
							<Button
								data-testid={
									testIdPrefix
										? `${testIdPrefix}-${navItem.name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}-mobile`
										: undefined
								}
								className={`${
									navItem.name === current
										? cx(classes.curveButton, classes.curveButtonCurrent)
										: classes.curveButton
								} largeBtn`}
								onClick={(e) => {
									setAnchorElMobile(e.currentTarget);
									setSelectedButtonMobile(index);
									onClick(navItem.url);
								}}
								key={index}
							>
								{navItem.name}
								{navItem?.dropdown?.length > 0 && (
									<MenuDropdown
										index={index}
										selectedButton={selectedButtonMobile}
										anchorEl={anchorElMobile}
										content={navItem.dropdown}
										applicationName={applicationName}
									/>
								)}
							</Button>
						);
					})}
				</ButtonGroup>
			</div>
		</>
	);
};

NavButtons.propTypes = {
	/** is array of objects containing name of the nav and its dropdown menu if any */
	navigation: PropTypes.array.isRequired,

	/** the current name of the application or site*/
	applicationName: PropTypes.string,

	//** this is the name of the nav current selected */
	current: PropTypes.string.isRequired,

	hideMobileViewBackground: PropTypes.bool,
	testIdPrefix: PropTypes.string,
};

NavButtons.defaultProps = {
	onClick: () => {},
	hideMobileViewBackground: false,
	testIdPrefix: undefined,
};

export default NavButtons;
